import NotFound from './NotFound';

export default {
  path: '*',
  key: '/error',
  component: NotFound,
};
